<template>
	
<div ref="summary" class="summary">

	<template v-if="!currentAlert">

	<com-risk :section="section" />
	<com-why :section="section" />
	<com-improve :section="section" />
	<com-treatment :section="section" v-if="$getValue('aid.treatment')" />
	<com-form :section="section" v-if="$getValue('aid.treatment')" />

	<vue-html2pdf ref="html2Pdf" :enable-download="is.pdfing" :filename="'bonehealthrecord patient id '+ $getValue('patient.id')" :manual-pagination="true" v-on:beforeDownload="onPDFGenerating($event)" v-on:hasDownloaded="onPDFComplete($event)">

		<section slot="pdf-content" class="pdf is-pdf">

			<div class="pdf-title">My Bone Health Record</div>

			<section class="pdf-item">
				<com-risk :section="section" />
				<com-why :section="section" />
				<com-improve :section="section" />
			</section>

			<div class="summary-id is-end">

				Patient ID - {{ $getValue('patient.id') }}<br/>
				For more information about this iFraP tool please see <a href="https://www.ifrap.co.uk/patient" target="_blank">www.ifrap.co.uk/patient</a> or scan the QR code

				<div class="qr"></div>

			</div>

			<div class="html2pdf__page-break"/>

			<section class="pdf-item" v-if="$getValue('aid.treatment')">
				<com-treatment :section="section" />
				<com-form :section="section" v-if="$getValue('aid.treatment')" />
			</section>

			<div class="summary-id is-end">

				Patient ID - {{ $getValue('patient.id') }}<br/>
				For more information about this iFraP tool please see <a href="https://www.ifrap.co.uk/patient" target="_blank">www.ifrap.co.uk/patient</a> or scan the QR code

				<div class="qr"></div>

			</div>

		</section>

	</vue-html2pdf>
	
	<div class="summary-actions">

		<div class="summary-actions-item is-print" v-on:click="onPrintClick" :class="{'is-loading': is.printing}"><span>Print</span></div>
		<div class="summary-actions-item is-pdf" v-on:click="onPDFClick" :class="{'is-loading': is.pdfing}"><span>Save</span></div>

	</div>

	<div class="summary-buttons">

		<com-button v-on:click="onCloseClick">Close iFraP tool</com-button>
		<com-button v-on:click="onRestartClick" v-if="!$isPatient">Re-start for new patient</com-button>

	</div>

	<div class="summary-id">

		Patient ID - {{ $getValue('patient.id') }}

	</div>

	</template>

</div>

</template>

<script>

import comButton from './../../common/Button'
import comForm from './summary/Form'
import comRisk from './summary/Risk'
import comWhy from './summary/Why'
import comImprove from './summary/Improve'
import comTreatment from './summary/Treatment'

import VueHtml2pdf from 'vue-html2pdf'

export default {

	props: ['section'],

	components: {
		VueHtml2pdf,
		'com-button': comButton,
		'com-risk': comRisk,
		'com-form': comForm,
		'com-why': comWhy,
		'com-improve': comImprove,
		'com-treatment': comTreatment
	},

	data: function() {

		return {
			is: {
				printing: false,
				pdfing: false
			}
		}

	},

	watch: {

		currentAlert: function(n) {

			if(!n) {

				this.$nextTick(function() {

					if (this.is.pdfing) {

						this.$refs.html2Pdf.generatePdf()

					} else if (this.is.printing) {

						this.$refs.html2Pdf.generatePdf()

					}

				}.bind(this))

			}

		}

	},

	computed: {

		dynamicAlert: function() {

			return this.$store.getters['session/alerts/dynamic']

		}
	
	},

	methods: {

		onPrintClick: function() {

			// eslint-disable-next-line
			gtag('event', 'click', {
				'event_category': 'button',
				'event_label': 'print'
			})

			this.is.printing = true

			this.$refs.html2Pdf.generatePdf()

			//this.promptID()

		},

		onPDFClick: function() {

			// eslint-disable-next-line
			gtag('event', 'click', {
				'event_category': 'button',
				'event_label': 'pdf'
			})

			this.is.pdfing = true

			this.$refs.html2Pdf.generatePdf()

			//this.promptID()

		},

		promptID: function() {

			this.$store.commit('session/alerts/dynamic', {
				type: this.$constants.alert.type.warning,
				name: 'Error',
				message: '<p>Please provide a Patient ID for this record</p>',
				visibility: {
					enabled:  this.$constants.visibility.sometimes,
					logic: {}
				},
				inputs: [4],
				buttons: {
					enabled:  this.$constants.visibility.always,
					logic: {},
					items: [{
						type:  this.$constants.button.type.review,
						variable: 0,
						text: 'Confirm',
						value: 0,
						visibility: {
							enabled:  this.$constants.visibility.always,
							logic: {}
						}
					}]
				}
			})

			this.$store.commit('session/alerts/current', true)

		},

		onPDFGenerating: async function(e) {

			if (this.is.printing) {

				await e.html2pdf().set(e.options).from(e.pdfContent).toPdf().get('pdf').then(function(pdf) {

					var win = window.open(pdf.output('bloburl'), '_blank');
					win.focus();
					win.print();
						
					this.is.printing = false

				}.bind(this))

			}

		},

		onPDFComplete: function() {

			this.is.pdfing = false

		},

		onCloseClick: function() {

			this.$router.push({
				name: 'Home'
			})

		},

		onRestartClick: function() {

			this.$store.commit('session/reset')

		}

	}
	
}

</script>

<style scoped>

.summary-actions {
	display: flex;
	justify-content: center;
}

@media print {

	.summary {
		padding: 32px;
	}

	.summary-actions {
		display: none;
	}

	.vue-html2pdf {
		display: none;
	}

	.summary-buttons {
		display: none;
	}

}

.summary-actions-item {
	width: 64px;
	height: 64px;
	border-radius: 32px;
	background-color: #F8A533;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	cursor: pointer;
	margin: 24px 10px 0px 10px;
}

.summary-actions-item.is-print {
	background-image: url(~@/assets/icon.print.svg);
}

.summary-actions-item.is-pdf {
	background-image: url(~@/assets/icon.pdf.svg);
}

.is-patient .summary-actions-item.is-pdf {
	background-image: url(~@/assets/icon.pdf.patient.svg);
}

.summary-actions-item.is-loading {
	pointer-events: none;
	background-image: url(~@/assets/load.gif);
}

.summary-actions-item span {
	color: #343434;
	font-weight: 600;
	font-size: 12px;
	text-transform: uppercase;
	display: block;
	width: 64px;
	text-align: center;
	letter-spacing: 1px;
	position: absolute;
	top: -24px;
}

.summary-buttons {
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	margin-top: 64px;
}

.summary-buttons >>> button {
	margin: 0px 10px;
	width: 300px;
}

@media print {

	.summary-buttons {
		display: none;
	}

}

.summary-foot {
	margin-top: 32px;
	font-size: 14px;
	color: #656D78;
	text-align: center;
}

.summary-id {
	margin: 32px 16px 0px 16px;
	font-size: 14px;
	color: #656D78;
	text-align: left;
	display: none;
}

.summary-id.is-end {
	height: 64px;
	padding-top: 16px;
}

.is-pdf .summary-id {
	margin-top: 0px;
}

@media print {

	.summary-foot {
		display: none;
	}

	.summary-id {
		display: block;
	}

}

.summary-foot a {
	text-decoration: underline;
}

.pdf >>> .summary-id {
	display: block;
}

.pdf-item {
	padding: 16px;
}

.pdf-item >>> div.risk,
.pdf-item >>> div.why,
.pdf-item >>> div.improve,
.pdf-item >>> div.treatment,
.pdf-item >>> div.form {
	border-bottom: 0px;
	margin-bottom: 0px;
	padding-bottom: 0px;
}

.pdf-item >>> .is-divide {
	border-top: 0px;
	padding-top: 0px;
}

.pdf-item >>> div.risk {
	margin-bottom: 16px;
}

.pdf-item >>> .treatment-subtitle {
	margin-bottom: 16px;
	padding-top: 0px;
	border-top: 0px;
}

.pdf-title {
	color: #343434;
	font-size: 24px;
	line-height: 24px;
	font-weight: 500;
	padding: 20px 15px 0px 15px;
	letter-spacing: 3px;
	text-transform: uppercase;
	flex-shrink: 0;
}

.qr {
	position: absolute;
	display: block;
	right: 0px;
	top: 0px;
	width: 64px;
	height: 64px;
	background-size: 64px 64px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url('data:image/png;base64,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');
}

</style>